<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card border-variant="primary">
          <template slot="header">
            <i class='fa fa-align-justify'></i>Admin Action Log
          </template>
          <!-- detail search start -->
          <b-card v-show="so.adv">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_date"> Time
                  <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="opt_group">Result</label>
                <br>
                <select v-model="so.opt['is_valid']" @change="refresh">
                    <option disabled value="">Please select Success or Failed</option>
                    <option value="true">Success</option>
                    <option value="false">Failed</option>
                  </select>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="6" v-if="!user">
              <b-form-group>
                <label for="opt_username_admin">username</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_username_admin" v-model="so.opt['username']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="opt_addr_admin">IP Address</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_addr_admin" v-model="so.opt['addr']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="opt_agent_admin">Agent</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_agent_admin" v-model="so.opt['agent']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="opt_action_admin">Action</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_action_admin" v-model="so.opt['action']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <label for="ph_search_opt_type">Match Type</label>
              <b-form-group>
                <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                  <b-form-radio value="and">[AND]:Match all</b-form-radio>
                  <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group class="float-right">
            <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
            <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
          </b-form-group>
        </b-card>
        <!-- detail search end -->
        <!-- summary tag start -->
        <hr>
        <b-row>
          <b-col sm="12" md="12">
              <b-badge class="mx-2" :variant="color[index % color.length]" v-for="(item, index) in _summary" :key="item.app_id">
                {{item.action}} : {{item.count}}
              </b-badge>
            </b-col>
        </b-row>
        <!-- summary tag end -->
        <hr>
          <b-row>
            <b-col sm="2"></b-col>
            <b-col sm="10" class="md-10">
              <b-input-group size="sm">
                <b-input-group-prepend>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                  <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                    <b-dropdown-item v-if="!user" size="sm" @click="so.sk='username';so.skt='username'; so.sv = ''">Username</b-dropdown-item>
                    <b-dropdown-item size="sm" @click="so.sk='action';so.skt='Action'; so.sv = ''">Action</b-dropdown-item>
                    <b-dropdown-item size="sm" @click="so.sk='addr';so.skt='Address'; so.sv = ''">Address</b-dropdown-item>
                    <b-dropdown-item size="sm" @click="so.sk='agent';so.skt='Agent'; so.sv = ''">Agent</b-dropdown-item>
                  </b-dropdown>
                  <!-- <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_valid'" @change="$refs._list.refresh()">
                    <option disabled value="">Please select Success or Failed</option>
                    <option value="true">Success</option>
                    <option value="false">Failed</option>
                  </select> -->
                </b-input-group-prepend>
                <b-form-input :disabled="so.adv" v-if="so.sk != 'is_valid'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-input-group size="sm">
                <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Show count : Default 15</option>
                    <option value=10>10</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                  </select>

                  <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                    <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                    <b-btn @click="pause" size="sm" variant="warning">
                      {{!sync.stop ? "Auto refresh"  : "Pause"}}
                    </b-btn>
                  </span>
              </b-input-group>
            </b-col>
          </b-row>
          <hr>
          <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
            <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
            <template slot="username" slot-scope="row">{{row.item.username}}</template>
            <template slot="source" slot-scope="row">{{row.item.source}}</template>
            <template slot="action" slot-scope="row">{{row.item.action}}</template>
            <template slot="addr" slot-scope="row">{{row.item.addr}}</template>
            <template slot="agent" slot-scope="row">{{row.item.agent | truncate(40) }}</template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
            </template>
          </b-table>
          <hr>
          <b-row>
            <b-col class="md-8">
              <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';


const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

export default {
  name : "ActionListAdmin",
  props: ['user', 'auto_refresh'],
  components: { DatePicker },
  data: () => ({
    color : ['info', 'danger', 'primary', 'secondary', 'warning', 'light'],
    custom,
    so : default_opt(),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summaryData : [],
  }),
  computed: {
    _summary() { return this.summaryData },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Time' },
        { key: 'username', sortable: true, label: 'Username'},
        { key: 'source', sortable: false, label: 'From' },
        { key: 'addr', sortable: false, label: 'IP Address' },
        { key: 'action', sortable: false, label: 'Action' },
        { key: 'agent', sortable: false, label: 'Agent' },
        { key: 'func', sortable: false, label: 'Select' },
      ]
      if(this.user) { f.splice(1, 1) }
      return f;
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'log.action', cmd : 'list.admin',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'admin_id', value : this.user.id, op : '=' }) }
      if(this.so.sk && this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { console.info(item); this.$router.push(`/log/action/${item.id}/admin`); },
    summary() {
      let and = [];
      let id = undefined;
      if(this.user) { id = this.user.id; and.push({ name : 'admin_id', value : id, op : '='}) }
      // Api.Manager({ target : 'log.action.admin', cmd : 'summary.admin', body : { and : and, or : [], sort : [] } })
      //   .then(rs => this.summaryData = rs.body)
      //   .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created() { console.log('log.action.admin.vue', 'created'); },
  destroyed() { console.log('log.action.admin.vue', 'destroyed'); },
  mounted() {
    console.log('log.action.admin.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
    setTimeout(this.summary, 1000)
  },
}
</script>
